import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

const applyInitialTheme = () => {
  try {
    const storedTheme = localStorage.getItem('theme_preference');
    const theme = storedTheme === 'dark' ? 'dark' : 'light';
    document.documentElement.dataset.theme = theme;
  } catch (error) {
    document.documentElement.dataset.theme = 'light';
  }
};

applyInitialTheme();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
); 
